import { render, staticRenderFns } from "./DeliveryTypeSelect.vue?vue&type=template&id=4fd28df8&scoped=true"
import script from "./DeliveryTypeSelect.vue?vue&type=script&lang=js"
export * from "./DeliveryTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd28df8",
  null
  
)

export default component.exports